export const initialPreferenceValues = {
  apply_tds_at: "Transaction level",
  id: 0,
  is_enabled: false,
  organization_id: 0,
  support_tds_for: "Customers and Vendors",
};
